<template>
    <div class="semi-circular-progress">
        <svg :width="width" :height="height" viewBox="0 0 140 70">
            <path  class="circle-bg" :d="circlePath" fill="none" :stroke="inactiveColor"  :stroke-width="strokeWidth"  />
            <path class="circle" :d="circlePath"  fill="none"  :stroke="activeColor" :stroke-width="strokeWidth"  :stroke-dasharray="calcCircumference"  :stroke-dashoffset="calcOffset"/>
        </svg>
        <div class="progress-text">
            {{ progressText }}
        </div>
    </div>
</template>

<script>
export default {
    props: {
        percentage: {
            type: [Number,String],
            required: true,
            default:0
        },
        width: {
            type: Number,
            default: 140
        },
        height: {
            type: Number,
            default: 70
        },
        strokeWidth: {
            type: Number,
            default: 5
        },
        inactiveColor: {
            type: String,
            default: '#e6e6e6'
        },
        activeColor: {
            type: String,
            default: '#2990FF'
        },
        progressText:{
            type: String,
            default: ''
        }
    },
    computed: {
        calcCircumference() {
            return 60 * Math.PI; // 半圆的周长
        },
        calcOffset() {
            let percentage = this.percentage > 100 ? 100 : this.percentage;
            return this.calcCircumference * (1 - Number(percentage) / 100);
        },
        circlePath() {
            return `M 9,75
              A 58,56 0 0 1 130,75`;
        }
    },
    created() {

    }
};
</script>

<style scoped>
.semi-circular-progress {
    display: inline-block;
    position: relative;
}
.circle-bg {

}
.circle {
    stroke-linecap: round;
    transition: stroke-dashoffset 0.3s ease;
}
.progress-text {
    position: absolute;
    width: 90%;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
    font-size: 12px;
    font-weight: bold;
    line-height: 18px;
    margin-top: 12px;
    color: #333;
}
</style>